import { render, staticRenderFns } from "./ManagePermission.vue?vue&type=template&id=3ecececd&"
import script from "./ManagePermission.vue?vue&type=script&lang=js&"
export * from "./ManagePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports